import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React, { useState } from "react";
import styled from "styled-components";
import FormSection from "../../../FormComponents/FormSection";
import cuideoTheme from "../../../../../../../../containers/themes/defaultTheme";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { TServiceValuationForm } from "../../types";
import ServiceHolderFindModal from "../ServiceHolderFindModal/ServiceHolderFindModal";
import { Alert } from "@material-ui/lab";
import { TGetServiceHolderResponse } from "../../../../../../../../api/serviceHolder/apiGetServiceHolder";
import ViewInZohoButton from "../../../../../../components/ViewInZohoButton";

const StyledRadioGroup = styled(RadioGroup)`
  .MuiSvgIcon-root {
    width: 1.25rem;
    height: 1.25rem;
  }

  .MuiFormControlLabel-label {
    font-size: 0.875rem;
    color: ${cuideoTheme.palette.primary.light};
  }
`;

const StyledExistingAlert = styled(Alert)`
  .MuiAlert-message {
    font-size: 0.875rem;
    line-height: 1.35;
  }
`;

interface IServiceHolderOpFormProps {
  onServiceHolderReset: () => void;
  onServiceHolderSelect: (serviceHolder: TGetServiceHolderResponse) => void;
}

const ServiceHolderOpForm = (props: IServiceHolderOpFormProps) => {
  const { onServiceHolderReset, onServiceHolderSelect } = props;
  const formikContext = useFormikContext<TServiceValuationForm>();
  const { formatMessage } = useIntl();
  const [state, setState] = useState({
    open: false,
  });

  const handleServiceHolderOpChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    if (value === "existing") {
      setState({ open: true });
    } else {
      onServiceHolderReset();
    }
  };

  const handleCancel = () => {
    setState({ open: false });
    formikContext.setFieldValue("service_holder_op", "new", true);
  };

  const handleServiceHolderSelect = (
    serviceHolder: TGetServiceHolderResponse
  ) => {
    setState({ open: false });
    onServiceHolderSelect(serviceHolder);
  };

  return (
    <FormSection>
      <FormControl component="fieldset">
        <StyledRadioGroup
          name="service_holder_op"
          value={formikContext.values.service_holder_op}
          onChange={handleServiceHolderOpChange}
        >
          <FormControlLabel
            value="new"
            control={<Radio color="primary" />}
            label={formatMessage({
              id: "ServiceValuationForm.Op.New",
              defaultMessage: "Usuario nuevo",
            })}
          />
          <FormControlLabel
            value="existing"
            control={<Radio color="primary" />}
            label={formatMessage({
              id: "ServiceValuationForm.Op.Existing",
              defaultMessage: "Usuario existente",
            })}
          />
        </StyledRadioGroup>
        {formikContext.values.service_holder_op === "existing" && (
          <StyledExistingAlert severity="warning">
            <FormattedMessage
              id="ServiceHolderOpForm.EditingExisting"
              defaultMessage="Al tener seleccionado un usuario existente en vez de crear un usuario nuevo estarás modificando los datos del usuario existente. Estás editando: {Name}"
              values={{
                Name: (
                  <strong>
                    {formikContext.values.service_holder_crm_id_name}
                  </strong>
                ),
              }}
            />
            <Box mt={8}>
              <ViewInZohoButton
                zohoId={formikContext.values.service_holder_crm_id}
                zohoModule="ServiceHolder"
              />
            </Box>
          </StyledExistingAlert>
        )}
      </FormControl>
      <ServiceHolderFindModal
        open={state.open}
        onCancel={handleCancel}
        onServiceHolderSelect={handleServiceHolderSelect}
      />
    </FormSection>
  );
};

export default ServiceHolderOpForm;
